export default __webpack_public_path__ + "static/media/38.e26847ad.png";